import img1 from "./image/user.jpg";

const TesimonialData = [
  {
    id: 1,
    name: "John Njogaa",
    Timg: img1,
    Tdegicnation: "Chief Executive - Montecito Ltd",
    Trating: 5,
    TReviweText:
      "Putting together a website is difficult enough; finding the correct person or firm is even more difficult. The company that could build, design, and optimize my website. Thank God I met with The Virtual BD at Khulna, Bangladesh ,  The Virtual BD  can also guide you through the process and beyond",
  },
  {
    id: 2,
    name: "Natacha Gaymer",
    Timg: img1,
    Tdegicnation: "Jones, SWOON Advertising",
    Trating: 5,
    TReviweText:
      "The Virtual BD has been a terrific experience for me. They have a keen sense of intuition and treat each job with exceptional care and inventiveness. I've worked with a lot of web design firms, and they are by far the most knowledgeable and competent. The Virtual BD to give the best of the best to my clientele.",
  },
  {
    id: 3,
    name: "Cameron Loren",
    Timg: img1,
    Tdegicnation: "Cystic Fibrosis Trust",
    Trating: 5,
    TReviweText:
      "This has been a fantastic experience. Everyone was exceedingly accommodating and receptive to my suggestions. I've worked with a lot of web design firms, and they are by far the most knowledgeable and competent. I'm quite proud of what we've accomplished. Thank you for your dedication and patience",
  },
  {
    id: 4,
    name: "Nico kovac,",
    Timg: img1,
    Tdegicnation: "Wave Sales Limited",
    Trating: 5,
    TReviweText:
      "I was really pleased with your service; my objectives were satisfied in a thorough manner in a timely and cost-effective manner and communication has improved both locally and nationally.Thank All The Virtual BD member I've benefited from the service. Web Design Express has been a substantial and wonderful experience.",
  },
  {
    id: 5,
    name: "Tom Schultze",
    Timg: img1,
    Tdegicnation: "PinPoint Marketing",
    Trating: 5,
    TReviweText:
      "Digital Marketing Services is presently one of the most successful and fastest growing businesses on the planet. Products associated to the digital marketing world, such as phones, computers, email, and digital services, affect people's lives and inspire them to be more active and comfortable in this field",
  },
];
export default TesimonialData;
